import React, { useState, useEffect } from 'react';
import HomeFilter from './HomeFilter';

const NFT = () => {
  const [coins, setCoins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNFTCoins = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/coins/nft`);
        
        if (!response.ok) {
          throw new Error(`Failed to fetch NFT data (status ${response.status})`);
        }
        
        const data = await response.json();
        
        if (data.error) {
          throw new Error(data.error);
        }
        
        // Format the data for display
        const formattedData = data.map(coin => ({
          ...coin,
          current_price: coin.current_price?.toLocaleString('en-US', {
            //style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: coin.current_price < 1 ? 6 : 2
          }),
          market_cap: coin.market_cap?.toLocaleString('en-US', {
            //style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 0
          }),
          total_volume: coin.total_volume?.toLocaleString('en-US', {
            //style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 0
          })
        }));
        
        setCoins(formattedData);
        setError(null);
      } catch (err) {
        console.error('Error fetching NFT coins:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchNFTCoins();
  }, []);

  if (error) return <div className="text-center py-10 text-red-500">{error}</div>;

  return (
    <div className="home_wrapper">
      <HomeFilter 
        coins={coins} 
        showTimeframes={true}
      />
    </div>
  );
};

export default NFT;